import styled from 'styled-components';

export const $OpenButtonWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const $OpenButton = styled.span<{ $isClickable?: boolean }>`
  display: ${({ $isClickable }) => ($isClickable ? 'inline-flex' : 'none')};
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.neutral._60};
  background-color: ${({ theme }) => theme.colors.neutral._10};
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
  position: absolute;
  left: -30px;
  top: 50%;
  transform: translateY(-50%);

  .row:hover & {
    opacity: 1;
  }

  svg {
    width: 12px;
    height: 12px;
  }
`;
